<template>
  <BaseEmptyState
    title="Não há nenhuma tabela de frete criada"
    subtitle="Você ainda não criou nenhuma tabela de frete. Comece agora criando a primeira."
    button-text="Nova tabela"
    button-aria-label="Criar nova tabela de frete"
    :show-button="canCreate"
    @action="$emit('create')"
  />
</template>

<script>
import BaseEmptyState from "@/shared/components/BaseEmptyState.vue";

export default {
  name: "FreightTablesEmptyState",
  components: { BaseEmptyState },
  props: {
    canCreate: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
